import { useEffect, useRef, useState } from "react";
import { emptys } from "../data/main";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import PersonIcon from "@mui/icons-material/Person";
import { strLang } from "../functions/strLang";
import Map from "ol/Map";
import { Polygon } from "ol/geom";
import View from "ol/View";
import { defaults } from "ol/interaction";
import Feature from "ol/Feature";
import TileLayer from "ol/layer/Tile";
import VectorLayer from "ol/layer/Vector";
import VectorSource from "ol/source/Vector";
import Attribution from "ol/control/Attribution";
import { Style, Stroke, Fill } from "ol/style";
import XYZ from "ol/source/XYZ";
import { avatarImages } from "../data/avatarsData";
import { createMarker, newStyle } from "../TheMap/functions/createMarker";
import { checkAllDone } from "../TheMap/functions/checkAllDone";
import { reOrder } from "../TheMap/functions/reOrder";
import { svgIcons } from "../data/svgIcons";
import { GroupIcon } from "./components/GroupIcon";
import { CircularProgress } from "@mui/material";
import { getMainInfo } from "../services/menu";
import { getCurrentDate } from "../utilities/getCurrentDate";
import { providerTile } from "../data/tilesList";
import { colorsList } from "../data/colorsList";
import StdButton from "../components/StdButton";
import { removeAccents } from "../functions/removeAccents";
import MiniNumberCircle from "./components/MiniNumberCircle";

var polyGroup2 = [];
var allPoints2 = [];
var allAddress2 = [];
var mainView2 = false;
var tile_layer2 = false;
var area_layer2 = false;
var points_layer2 = false;
var absIndex = { id: 0, index: 0, time: 0 };
var dragId = false;
var mainWidth = 0;

export default function useTheGroups(props) {
  const [openModal, setOpenModal] = useState({ status: false, group: false });
  const [group, setGroup] = useState({ id: 0, index: 0 });
  const [btns, setBtns] = useState(0);
  const [search, setSearch] = useState("");
  const [status, setStatus] = useState(false);
  const [headerInfo, setHeaderInfo] = useState({});
  const [avatarsData, setAvatarsData] = useState([]);
  const [territories, setTerritories] = useState([]);
  const [openInput, setOpenInput] = useState({
    status: false,
    text: "",
  });
  const mapElement = useRef();

  const [iconList, setIconList] = useState([
    { users: 0, total: 0 },
    { id: 1, users: 0, total: 0, lock: 0 },
    { id: 2, users: 0, total: 0, lock: 0 },
    { id: 3, users: 0, total: 0, lock: 0 },
    { id: 4, users: 0, total: 0, lock: 0 },
    { id: 5, users: 0, total: 0, lock: 0 },
    { id: 6, users: 0, total: 0, lock: 0 },
    { id: 7, users: 0, total: 0, lock: 0 },
    { id: 8, users: 0, total: 0, lock: 0 },
  ]);

  const formattedDate = getCurrentDate();

  const [vmap, setvMap] = useState();
  const mapRef = useRef();
  mapRef.current = vmap;
  const [position, setPosition] = useState(false);
  const [isDragging, setIsDragging] = useState(false);

  const stylesLimit = [
    new Style({
      stroke: new Stroke({ color: "rgba(0, 0, 255, 0.3)", width: 3 }),
      fill: new Fill({ color: "rgba(0, 0, 255, 0.05)" }),
    }),
  ];

  const getCorrectSource = (data) => {
    if (emptys.includes(data)) {
      data = providerTile.OSM;
    }
    return new XYZ({
      url: data.url,
      attribution:
        "Powered by Esri. " +
        "Source: Esri, DigitalGlobe, GeoEye, Earthstar Geographics, CNES/Airbus DS, USDA, USGS, AeroGRID, IGN, and the GIS User Community",
      crossOrigin: "anonymous",
    });
  };

  useEffect(() => {
    tile_layer2 = new TileLayer({
      source: getCorrectSource(providerTile[localStorage.getItem("tile")]),
    });

    points_layer2 = new VectorLayer({
      id: "points_group",
      source: new VectorSource(),
    });

    area_layer2 = new VectorLayer({
      id: "area_layer",
      source: new VectorSource({ features: [] }),
      style: stylesLimit,
    });

    mainView2 = new View({
      projection: "EPSG:3857",
      center: [0, 0],
      //center: fromLonLat([-79.52038, 9.00938]),
      zoom: 13,
      maxZoom: 19,
    });

    const initialMap = new Map({
      target: mapElement.current,
      layers: [tile_layer2, area_layer2, points_layer2],
      view: mainView2,
      controls: defaults({ attribution: new Attribution() }),
      interactions: defaults({ doubleClickZoom: false }),
    });
    initialMap.on("click", handleMapClick);
    setvMap(initialMap);
  }, []);

  useEffect(() => {
    if (props.mapData) {
      setHeaderInfo({
        ...headerInfo,
        ter: { id: props.mapData.id, name: props.mapData.title },
      });
      allAddress2 = reOrder(props.mapData.address);
      allPoints2 = props.mapData.points;

      points_layer2.getSource().clear();

      if (props.mapData.limits.length > 0 && props.mapData.renew) {
        area_layer2.getSource().clear();
        polyGroup2 = [];
        props.mapData.limits.map((o) => {
          if (typeof o.LIMITS === "string") {
            o.LIMITS = new Polygon([JSON.parse(o.LIMITS)])
              .transform("EPSG:4326", "EPSG:3857")
              .getCoordinates();
          }
          if (o.LIMITS[0].length > 0) {
            polyGroup2.push({
              id: o.ID,
              name: o.NOM,
              color: o.LCOLOR,
              coords: o.LIMITS,
            });
          }
          // console.log("polyGroup2", polyGroup2);
          return true;
        });

        if (polyGroup2.length > 0) {
          polyGroup2.map((o) => {
            let poly = new Feature({
              id: o.id,
              name: o.name,
              color: o.color,
              geometry: new Polygon([o.coords[0]]),
            });
            if (o.color) {
              let _rgb = o.color.split(",");
              if (_rgb.length === 3) {
                let _style = new Style({
                  fill: new Fill({
                    color: `rgba(${_rgb.join(",")}, 0.05)`,
                    weight: 1,
                  }),
                  stroke: new Stroke({
                    color: `rgba(${_rgb.join(",")}, 0.5)`,
                    width: 3,
                  }),
                });
                poly.setStyle(_style);
              }
            }
            area_layer2.getSource().addFeature(poly);
            return true;
          });
          mapRef.current.getView().fit(area_layer2.getSource().getExtent(), {
            padding: [10, 10, 10, 10],
          });
        }
      }

      let tempiconList = iconList;
      tempiconList.map((o) => (o.total = 0));

      allPoints2.forEach((o) => {
        o.ADDRS = props.mapData.address.filter(
          (v) => Number(v.PUNTO) === Number(o.PUNTOS)
        ).length;

        if (o.SHAPE > 0) {
          tempiconList[tempiconList.findIndex((e) => e.id === o.SHAPE)].total +=
            o.ADDRS;
        } else {
          tempiconList[0].total += o.ADDRS;
        }

        if (Number(o.SEC) > 0) {
          o.STATUS = checkAllDone(o.PUNTOS, allAddress2, o.COLOR);
          createMarker(o, "point", points_layer2, false, false);
        }

        // if (props.mapData.renew) {
        //   if (
        //     props.mapData.centerpoint === "reload" &&
        //     localStorage.getItem("zoom")
        //   ) {
        //     mapRef.current
        //       .getView()
        //       .setCenter(JSON.parse(localStorage.getItem("coords")));
        //     mapRef.current.getView().setZoom(localStorage.getItem("zoom"));
        //   } else if (Number(props.mapData.centerpoint) === Number(o.PUNTOS)) {
        //     mapRef.current
        //       .getView()
        //       .setCenter(
        //         fromLonLat([o.LAT, o.LON]),
        //         "EPSG:32643",
        //         "EPSG:32643"
        //       );
        //     mapRef.current.getView().setZoom(19);
        //     // moveHere(fromLonLat([o.LAT, o.LON]));
        //   } else if (area_layer2.getSource().getFeatures().length === 0) {
        //     mapRef.current
        //       .getView()
        //       .fit(points_layer2.getSource().getExtent(), {
        //         padding: [50, 50, 50, 50],
        //       });
        //   }
        // }
      });
      setIconList([...tempiconList]);
      // let newTile =
      //   props.mapData.mapTile === ""
      //     ? localStorage.getItem("tile")
      //     : props.mapData.mapTile;
      // if (currentTile != newTile) {
      //   changeTile(newTile);
      // }
    }
  }, [props.mapData]);

  useEffect(() => {
    mainWidth = props.width;
  }, [props.width]);

  const writeIcons = () => {
    return iconList.map((item, index) => {
      let avaTotal = avatarsData.filter((o) => o.MGROUP === item.id).length;
      return (
        (avaTotal > 0 || item.total > 0 || !item.id) && (
          <div
            key={index}
            onClick={() => {
              // console.log("item", item.id);
              setGroup({ id: item.id ?? false, index });
              absIndex = { ...absIndex, id: item.id ?? false, index };
            }}
            style={{
              position: "relative",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <GroupIcon
              id={item.id}
              fill={
                group.id === item.id
                  ? svgIcons[item.id].color
                  : !item.id && !group.id
                  ? "default"
                  : "gray"
              }
              style={{
                height:
                  group.id === item.id || (!item.id && !group.id) ? 40 : 30,
                width:
                  group.id === item.id || (!item.id && !group.id) ? 50 : 40,
                opacity:
                  group.id === item.id || (!item.id && !group.id) ? 1 : 0.5,
              }}
            />
            <MiniNumberCircle total={item.total} />
          </div>
        )
      );
    });
  };

  // map click handler
  const handleMapClick = (event) => {
    // const _coords = [...event.coordinate];
    const temp_feature = mapRef.current.forEachFeatureAtPixel(
      event.pixel,
      (feature, layer) => {
        return feature;
      }
    );
    if (temp_feature && ["point"].includes(temp_feature.get("group"))) {
      changeGroup(temp_feature);
    }
  };

  const changeGroup = (feature) => {
    // console.log("changeGroup", feature);
    let index = allPoints2.findIndex(
      (o) => Number(o.PUNTOS) === Number(feature.get("id"))
    );

    let add = true;
    let initialShape = allPoints2[index].SHAPE;

    if (allPoints2[index].SHAPE == absIndex.id) {
      delete allPoints2[index].SHAPE;
      add = false;
    } else {
      allPoints2[index].SHAPE = absIndex.id;
    }
    // console.log("absIndex", absIndex.id);
    // console.log("allPoints2[index]", allPoints2[index]);

    feature.set("shape", allPoints2[index].SHAPE);
    feature.setStyle(
      newStyle(
        allPoints2[index].SEC,
        checkAllDone(
          allPoints2[index].PUNTOS,
          allAddress2,
          feature.get("color")[0]
        ),
        allPoints2[index].SHAPE
      )
    );

    // points_layer2.getSource().removeFeature(feature);
    // createMarker(allPoints2[index], "point", points_layer2, false, false);
    countAddress(add, initialShape, allPoints2[index].ADDRS);
    assingPoint({
      point: allPoints2[index].PUNTOS,
      add,
      index,
      group: absIndex.id,
    });
  };

  const countAddress = (add, initialShape, total) => {
    let tempList = iconList;
    if (add) {
      tempList[absIndex.index].total += total;
      tempList[
        initialShape > 0 ? iconList.findIndex((e) => e.id === initialShape) : 0
      ].total -= total;
    } else {
      tempList[absIndex.index].total -= total;
      tempList[0].total += total;
    }

    setIconList([...tempList]);
  };

  // const miniIcon = (tGroup) => {
  //   if (tGroup) {
  //     return (
  //       <GroupIcon
  //         id={tGroup}
  //         fill={svgIcons[tGroup].color}
  //         style={{
  //           position: "absolute",
  //           left: -5,
  //           bottom: 0,
  //           height: 15,
  //           width: 15,
  //         }}
  //       />
  //     );
  //   } else {
  //     return null;
  //   }
  // };

  // const writeButtons = () =>
  //   ["groups", "map"].map((item, index) => (
  //     <div
  //       key={index}
  //       className="buttons"
  //       onClick={() => setBtns(index)}
  //       style={{
  //         backgroundColor: btns === index ? "blue" : "gray",
  //         minWidth: 70,
  //       }}
  //     >
  //       {strLang(item)}
  //     </div>
  //   ));

  const handleTouchStart = (e, item) => {
    // console.log(item);
    dragId = {
      id: item.ORD,
      index: item.INDEX,
      group: item.MGROUP,
      img: item.IMA,
      name: item.NOMBRE,
    };
    setIsDragging(true);
  };

  const handleTouchMove = (e) => {
    if (!isDragging) return;

    const touch = e.touches[0];
    const x = touch.clientX;
    const y = touch.clientY;

    setPosition({ x, y });
  };

  const handleTouchEnd = (e) => {
    try {
      const touch = e.changedTouches[0];
      const x = touch.clientX;
      const y = touch.clientY;

      const element = document.elementFromPoint(x, y);

      // if (element) {
      //   console.log("ID:", element.id, typeof element.id, dragId);
      // }
      // console.log(
      //   "rrr",
      //   Number(element.id),
      //   Number(element.id) > -1,
      //   Number(element.id) !== dragId.group
      // );
      if (Number(element.id) > 0 && Number(element.id) !== dragId.group) {
        assingGroup({
          avatar: dragId.id,
          add: element.id > 0 ? true : false,
          index: dragId.index,
          group: Number(element.id),
        });
      } else {
        dragId = false;
      }
    } catch (error) {
      console.log("handleTouchEnd error", error);
    }
    setIsDragging(false);
    setPosition(false);
  };

  const avatarsList = (type = 0, lock) => {
    let tempAva = avatarsData.filter((o) =>
      type ? o.MGROUP === type : !o.MGROUP
    );
    tempAva.sort((a, b) => a.NOMBRE.localeCompare(b.NOMBRE));
    return tempAva.map((item, index) => (
      <div
        id={type}
        key={index}
        onClick={() => {
          setOpenModal({ status: true, group: type });
        }}
        onTouchStart={(e) => {
          if (!lock) {
            handleTouchStart(e, item);
          }
        }}
        onTouchMove={(e) => {
          if (!lock) {
            handleTouchMove(e);
          }
        }}
        onTouchEnd={(e) => {
          if (!lock) {
            handleTouchEnd(e);
          }
        }}
        onMouseDown={(e) => {
          if (!lock) {
            handleTouchStart(e, item);
          }
        }}
        onMouseUp={(e) => {
          if (!lock) {
            handleTouchEnd(e);
          }
        }}
        style={{
          display: "flex",
          flexDirection: "row",
          fontSize: 20,
          alignItems: "center",
          marginRight: 10,
          whiteSpace: "nowrap",
          touchAction: lock ? null : type > 0 ? "none" : "pan-x",
        }}
      >
        {item.IMA > 0 ? (
          <div style={{ position: "relative" }}>
            <img
              id={type}
              src={avatarImages["ani" + item.IMA].svg}
              alt="avatar"
              style={{ width: 40 }}
            />

            {/* {miniIcon(item.MGROUP)} */}
          </div>
        ) : (
          <div>
            <PersonIcon style={{ fontSize: 40, color: "gray" }} />
          </div>
        )}
        {item.NOMBRE}
      </div>
    ));
  };

  const checkActivity = async () => {
    if (mainWidth > 0) {
      let payload = {
        type: "check_group",
        id: localStorage.getItem("activityCode"),
        time: absIndex.time,
      };
      // console.log("checkActivity payload", payload);
      const response = await getMainInfo(payload);
      // console.log("checkActivity response", response);
      if (response.status && response.update) {
        absIndex.time = response.time;
        getAvatarInfo();
        return true;
      }
    }
    setTimeout(checkActivity, 5000);
  };

  const getAvatarInfo = async () => {
    let payload = {
      type: "activity_get_avatars",
      date: formattedDate,
      code: localStorage.getItem("activityCode"),
      maincode: localStorage.getItem("code"),
    };
    // console.log("activity_get_avatars payload", payload);
    const response = await getMainInfo(payload);
    // console.log("activity_get_avatars response", response);
    if (response.status && response.avatars) {
      response.avatars.sort((a, b) => a.NOMBRE.localeCompare(b.NOMBRE));
      response.avatars.forEach((o, index) => {
        o.INDEX = index;
      });
      setAvatarsData([...response.avatars]);
      defineLock(response.lock);
      countUsers(response.avatars);
    }
    setTimeout(checkActivity, 5000);
  };

  const createAvatar = async (name) => {
    let payload = {
      type: "activity_new_avatar",
      name,
      date: formattedDate,
      time: getCurrentDate(true),
      id: localStorage.getItem("activityCode"),
      code: localStorage.getItem("code"),
      group: openModal.group,
    };
    // console.log("createAvatar payload", payload);
    const response = await getMainInfo(payload);
    // console.log("createAvatar response", response);
    if (response.status && response.avatars) {
      response.avatars.sort((a, b) => a.NOMBRE.localeCompare(b.NOMBRE));
      response.avatars.forEach((o, index) => {
        o.INDEX = index;
      });
      setAvatarsData([...response.avatars]);
      countUsers(response.avatars);
    }
  };

  const defineLock = (list) => {
    // console.log("defineLock", list);
    if (list.length > 0) {
      let tempList = iconList;
      tempList.map((o) => {
        if (o.id > 0) {
          o.lock = list[0]["g" + o.id];
        }
        return o;
      });
      setIconList([...tempList]);
    }
  };

  const openActivity = async () => {
    setStatus("waiting");
    let payload = {
      type: "activity_group",
      date: formattedDate,
      time: getCurrentDate(true),
      code: localStorage.getItem("code2"),
      maincode: localStorage.getItem("code"),
    };
    // console.log("openActivity payload", payload);
    const response = await getMainInfo(payload);
    // console.log("openActivity response", response);
    if (response.status) {
      response.avatars.sort((a, b) => a.NOMBRE.localeCompare(b.NOMBRE));
      response.avatars.forEach((o, index) => {
        o.INDEX = index;
      });
      setAvatarsData([...response.avatars]);
      setTerritories([...response.activity]);
      defineLock(response.lock);
      setStatus("ready");
      setHeaderInfo({
        ...headerInfo,
        id: response.code,
      });
      absIndex = { ...absIndex, time: response.time };
      localStorage.setItem("activityCode", response.code);
      countUsers(response.avatars, false, true);
      setTimeout(checkActivity, 5000);
    } else {
      setStatus(false);
    }
  };

  const assingPoint = async ({ point, add, index, group }) => {
    // console.log("assingPoint", point, index, add);
    let payload = {
      type: "activity_point",
      date: getCurrentDate(true),
      id: localStorage.getItem("activityCode"),
      map: localStorage.getItem("mapid"),
      point,
      group,
      add,
    };
    // console.log("assingPoint payload", payload);
    const response = await getMainInfo(payload);
    // console.log("assingPoint response", response);
    if (response.status) {
    } else {
    }
  };

  const assingGroup = async ({ avatar, add, index, group }) => {
    // console.log("assingGroup", avatar, index, add);
    let tempList = avatarsData;
    let backupValue = tempList[index].MGROUP;
    tempList[index].SEND = add;

    setAvatarsData([...tempList]);

    let payload = {
      type: "activity_avatar",
      id: headerInfo.id,
      avatar,
      group,
      add,
      time: getCurrentDate(true),
    };
    // console.log("payload", payload);
    const response = await getMainInfo(payload);
    // console.log("response", response);
    if (response.status) {
      if (add) {
        tempList[index].MGROUP = group;
      } else {
        delete tempList[index].MGROUP;
      }
    } else {
      tempList[index].MGROUP = backupValue;
    }
    delete tempList[index].SEND;
    setAvatarsData([...tempList]);
    countUsers(tempList, tempList[index].MGROUP);
  };

  const countUsers = (data, id = false, start = false) => {
    try {
      data = data.filter((e) => (id ? e.MGROUP === id : e.MGROUP > 0));
      let tempIcons = iconList;

      if (id) {
        const newId = tempIcons.findIndex((e) => e.id === id);
        tempIcons[newId].users = data.length;
      } else {
        tempIcons = tempIcons.map((v) => {
          return { ...v, users: data.filter((e) => e.MGROUP === v.id).length };
        });
      }
      setIconList([...tempIcons]);
      if (
        start &&
        tempIcons.filter((e) => e.users === 0).length === tempIcons.length
      ) {
        setOpenModal({ status: true, group: 1 });
      }
    } catch (error) {
      console.log("countUsers error", error);
    }
  };

  const avatarsBox = () => {
    let list1 = avatarsData.filter((o) => o.MGROUP === openModal.group);
    let list2 = avatarsData.filter((o) => !o.MGROUP);
    let list3 = avatarsData.filter(
      (o) => o.MGROUP && o.MGROUP !== openModal.group
    );
    let tempAva = [...list1, ...list2, ...list3];
    if (search.trim() !== "") {
      let tempSearch = removeAccents(search.trim()).toLowerCase();
      tempAva = tempAva.filter((e) =>
        removeAccents(e.NOMBRE.trim()).toLowerCase().includes(tempSearch)
      );
    }
    return tempAva.map(
      (item, index) =>
        item.ORD > 0 && (
          <div
            key={index}
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              whiteSpace: "nowrap",
              padding: 5,
              paddingLeft: 10,
              backgroundColor:
                item.MGROUP === openModal.group
                  ? colorsList.lightGreen2
                  : item.MGROUP && item.MGROUP !== openModal.group
                  ? colorsList.white
                  : colorsList.lightGrey,
            }}
          >
            {item.SEND ? (
              <CircularProgress size={24} />
            ) : item.MGROUP === openModal.group ? (
              <GroupIcon
                id={item.MGROUP}
                fill={svgIcons[item.MGROUP].color}
                onClick={() => {
                  assingGroup({
                    avatar: item.ORD,
                    add: false,
                    index: item.INDEX,
                    group: openModal.group,
                  });
                }}
                style={{
                  height: 25,
                  width: 25,
                }}
              />
            ) : item.MGROUP && item.MGROUP !== openModal.group ? (
              <GroupIcon
                id={item.MGROUP}
                fill={svgIcons[item.MGROUP].color}
                onClick={() => {
                  assingGroup({
                    avatar: item.ORD,
                    add: true,
                    index: item.INDEX,
                    group: openModal.group,
                  });
                }}
                style={{
                  height: 25,
                  width: 25,
                }}
              />
            ) : (
              <CheckBoxOutlineBlankIcon
                style={{ cursor: "pointer" }}
                onClick={() => {
                  assingGroup({
                    avatar: item.ORD,
                    add: true,
                    index: item.INDEX,
                    group: openModal.group,
                  });
                }}
              />
            )}
            <div style={{ position: "relative", marginLeft: 5 }}>
              {item.IMA > 0 ? (
                <img
                  src={avatarImages["ani" + item.IMA].svg}
                  alt="avatar"
                  style={{ width: 40 }}
                />
              ) : (
                <PersonIcon style={{ fontSize: 40, color: colorsList.grey }} />
              )}
            </div>
            <div>{item.NOMBRE}</div>
          </div>
        )
    );
  };

  const closeInput = (status = false) => {
    if (typeof status !== "boolean") {
      status = false;
    }

    setOpenInput({ status, text: "" });
  };

  const checkName = () => {
    let existName = avatarsData.filter(
      (o) =>
        o.NOMBRE.trim().toLowerCase() === openInput.text.trim().toLowerCase()
    );

    if (existName.length === 0) {
      let tempName = openInput.text;
      createAvatar(tempName);
      closeInput();
    } else {
      props.openMainMsg({ label: strLang("nameExists") });
    }
  };

  const handleLock = async (id, lock) => {
    let tempiconList = iconList;
    let index = tempiconList.findIndex((e) => e.id === id);
    tempiconList[index].lock = lock ? 0 : 1;
    setIconList([...tempiconList]);
    let payload = {
      type: "activity_lock",
      id: headerInfo.id,
      group: tempiconList[index].id,
      lock: tempiconList[index].lock,
      time: getCurrentDate(true),
    };
    // console.log("payload", payload);
    const response = await getMainInfo(payload);
    // console.log("response", response);
  };

  const newPerson = {
    title: strLang("name"),
    inputList: [
      {
        value: openInput.text,
        style: { width: 300 },
        change: (e) => setOpenInput({ ...openInput, text: e.target.value }),
      },
    ],
    buttons: [
      {
        label: strLang("create"),
        func: checkName,
        width: 80,
      },
      {
        label: strLang("cancel"),
        func: closeInput,
        width: 80,
        color: colorsList.darkGrey,
      },
    ],
  };

  const subMenuButtons = ["groups", "map"].map(
    (o, index) =>
      status && (
        <StdButton
          key={index}
          label={strLang(o)}
          onClick={() => setBtns(index)}
          color={btns === index ? null : colorsList.darkGrey}
          width={70}
        />
      )
  );

  const closeSelection = () => {
    setSearch("");
    setOpenModal({ status: false, group: false });
  };

  const selectionData = {
    buttons: [
      {
        label: strLang("close"),
        func: closeSelection,
      },
    ],
  };

  return {
    subMenuButtons,
    formattedDate,
    headerInfo,
    status,
    openActivity,
    btns,
    iconList,
    handleLock,
    avatarsList,
    setOpenModal,
    dragId,
    openModal,
    openInput,
    newPerson,
    isDragging,
    position,
    selectionData,
    search,
    setSearch,
    avatarsBox,
    mapElement,
    writeIcons,
    territories,
    setHeaderInfo,
    closeInput,
    avatarsData,
  };
}
